// ─── Gemeinsame Darstellungshelfer ──────────────────────────────────────────
//
// Dieselben Zahlen sollen überall gleich aussehen. Vorher lag `bytes` als
// Kopie in der Übersicht; mit jeder weiteren Seite wäre daraus eine Familie
// leicht verschiedener Formatierungen geworden.

export function bytes(n: number | null | undefined): string {
  if (n === null || n === undefined) return '–';
  if (n < 1024) return `${n} B`;
  const einheiten = ['KB', 'MB', 'GB', 'TB'];
  let wert = n / 1024;
  let i = 0;
  while (wert >= 1024 && i < einheiten.length - 1) {
    wert /= 1024;
    i++;
  }
  return `${wert.toFixed(wert < 10 ? 1 : 0)} ${einheiten[i]}`;
}

export function zeitpunkt(iso: string | null | undefined): string {
  if (!iso) return 'nie';
  return new Date(iso).toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function datum(iso: string | null | undefined): string {
  if (!iso) return '–';
  return new Date(iso).toLocaleDateString('de-DE');
}

export function zahl(n: number): string {
  return n.toLocaleString('de-DE');
}

/**
 * Beträge stehen überall in Cent, damit unterwegs nichts gerundet wird –
 * sichtbar werden sie erst hier.
 */
export function geld(cents: number | null | undefined, waehrung = 'EUR'): string {
  if (cents === null || cents === undefined) return '–';
  return (cents / 100).toLocaleString('de-DE', {
    style: 'currency',
    currency: waehrung,
  });
}

/** Laufzeit in etwas, das man vorlesen kann. */
export function dauer(sekunden: number): string {
  const tage = Math.floor(sekunden / 86400);
  const stunden = Math.floor((sekunden % 86400) / 3600);
  const minuten = Math.floor((sekunden % 3600) / 60);
  if (tage > 0) return `${tage} ${tage === 1 ? 'Tag' : 'Tage'}, ${stunden} h`;
  if (stunden > 0) return `${stunden} h ${minuten} min`;
  return `${minuten} min`;
}
